export default __webpack_public_path__ + "static/media/to.eaf7d9ab.svg";